import styled from 'styled-components';
import Row from '../../../components/dumbs/Row';
import { DocumentsAndSelfie as DocumentsAndSelfieSVG } from '~components';
import Column from '../../../components/dumbs/Column';
import Title from '../../../components/dumbs/Title';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Section = styled.section`
  display: flex;
  margin-top: 112px;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex-direction: column;
    margin-top: ${({ theme }) => theme.spacing.km10};
    gap: ${({ theme }) => theme.spacing.km6};
  }
`;

export const DocumentsAndSelfie = styled(DocumentsAndSelfieSVG)`
  margin-right: ${({ theme }) => theme.spacing.km16};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-right: ${({ theme }) => theme.spacing.km0};
    margin-bottom: ${({ theme }) => theme.spacing.km6};
  }
`;

export const ColumnDescription = styled(Column)`
  flex: 50% 0 0;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    flex: 1;
  }
`;

export const TitleDescription = styled(Title)`
  font-size: ${({ theme }) => theme.font.size.m6};
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  letter-spacing: -0.03em;
  margin-bottom: 0;
`;

export const ListDescription = styled.ul``;

export const ListItemGroup = styled(Row)`
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.km6};

  :first-of-type {
    margin-top: ${({ theme }) => theme.spacing.km5};

    @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
      margin-top: ${({ theme }) => theme.spacing.km6};
    }
  }

  :last-of-type {
    margin-bottom: ${({ theme }) => theme.spacing.km8};

    @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
      margin-bottom: ${({ theme }) => theme.spacing.km10};
    }
  }
`;

export const ListItemDescription = styled.li`
  margin-left: 18px;
  display: flex;
  flex: 1;
  font-weight: ${({ theme }) => theme.font.weight.regular};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  color: ${({ theme }) => theme.color.text.neutral.default};
  list-style: none;
  letter-spacing: -0.03em;
`;
